import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const LIST_ITEM_SKELETON_NAME = 'ListItemSkeleton';
export const LIST_ITEM_SKELETON_SLOTS: Array<keyof ListItemSkeletonClasses> = [
	'root',
	'startBox',
	'textBox',
	'buttonBox',
] as const;

export type ListItemSkeletonSlot = (typeof LIST_ITEM_SKELETON_SLOTS)[number];

export interface ListItemSkeletonClasses {
	root: string;
	startBox: string;
	textBox: string;
	buttonBox: string;
}

export type ListItemSkeletonClassKey = keyof ListItemSkeletonClasses;

export const getListItemSkeletonUtilityClass = (slot: string) =>
	generateUtilityClass(LIST_ITEM_SKELETON_NAME, slot as ListItemSkeletonSlot);

export const ListItemSkeletonClasses: ListItemSkeletonClasses =
	generateUtilityClasses(LIST_ITEM_SKELETON_NAME, [
		'root',
		'startBox',
		'textBox',
		'buttonBox',
	]);

export default ListItemSkeletonClasses;
